module.exports = __webpack_public_path__ + "img/solo-icon.0e447b84.svg";